module.exports = __webpack_public_path__ + "static/media/icon.602cfc4a.svg";